var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A46BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#F571A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDB86D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shineGradient",
    cx: 0.75,
    cy: 0.15,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logoClip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4c11.05 0 20 8.95 20 20s-8.95 20-20 20-20-8.95-20-20 8.95-20 20-20zm0 8c-6.63 0-12 5.37-12 12s5.37 12 12 12 12-5.37 12-12h-10c-1.1 0-2-.9-2-2V8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4c11.05 0 20 8.95 20 20s-8.95 20-20 20-20-8.95-20-20 8.95-20 20-20zm0 8c-6.63 0-12 5.37-12 12s5.37 12 12 12 12-5.37 12-12h-10c-1.1 0-2-.9-2-2V8z",
    fill: "url(#logoGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logoClip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 14,
    rx: 12,
    ry: 6,
    fill: "url(#shineGradient)",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIa);
export default __webpack_public_path__ + "static/media/image-ia.dc731ea82e6447127017ef8708a495d9.svg";
export { ForwardRef as ReactComponent };